import _NewbieCopy from "./NewbieCopy.jsx";
import withInstall from "../../utils/withInstall";
export const NewbieCopy = withInstall(_NewbieCopy);
export default NewbieCopy;
